import { CSSProperties, ReactNode } from 'react';

import { EditableSelect } from '../../selects/EditableSelect';

type FontSizePickerProps = {
  value: number;
  onChange: (newValue: number) => void;
  title?: string;
  leftSection?: ReactNode;
  leftSectionWidth?: number;
  inputClassNames?: Record<string, string>;
  style?: CSSProperties;
};

const fontSizeOptions = ['10', '12', '14', '16', '18', '20', '24', '28', '32', '36', '40', '48', '64', '96'];

export function FontSizePicker(props: FontSizePickerProps) {
  const { onChange, value, title, leftSection, leftSectionWidth, inputClassNames, style } = props;

  return (
    <EditableSelect
      testId="font-size-picker"
      data={fontSizeOptions}
      value={String(value)}
      setValue={value => {
        onChange(Number(value));
      }}
      type="number"
      title={title}
      leftSection={leftSection}
      leftSectionWidth={leftSectionWidth}
      inputClassNames={inputClassNames}
      style={style}
    />
  );
}
